var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "nft-collection",
      class: { full: _vm.isFull },
      on: { click: _vm.nftItemClick },
    },
    [
      _vm.isFull
        ? _c("span", { staticClass: "nft-label" }, [_vm._v("Collection Full")])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "nft-collection-inner",
          class: { empty: !_vm.collection.profile_image },
        },
        [
          _vm.collection.profile_image
            ? _c("img", {
                staticClass: "nft-collection-image",
                attrs: {
                  src: _vm.collection.profile_image.url,
                  width: "290",
                  height: "222",
                  loading: "lazy",
                  alt: `collection ${_vm.collection.title}`,
                },
              })
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "nft-collection-bottom" }, [
        _c("p", { staticClass: "nft-title" }, [
          _vm._v("\n      " + _vm._s(_vm.collection.title) + "\n    "),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "nft-status" }, [
          _vm._v("\n      " + _vm._s(_vm.nftStatus) + "\n    "),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }